export type ReelFlowPhase = 'idle' | 'starting' | 'polling' | 'delivered' | 'failed';

export type ReelFlowState = {
  phase: ReelFlowPhase;
  jobId: string | null;
  force: boolean;
};

export type ReelFlowEvent =
  | { type: 'ACQUIRE_START'; force: boolean }
  | { type: 'ACQUIRE_SUCCESS'; jobId: string }
  | { type: 'ACQUIRE_FAILURE' }
  | { type: 'POLL_DELIVERED' }
  | { type: 'POLL_FAILED' }
  | { type: 'OPEN_EXISTING'; jobId: string }
  | { type: 'RETRY' }
  | { type: 'RESET' };

export const INITIAL_REEL_FLOW_STATE: ReelFlowState = {
  phase: 'idle',
  jobId: null,
  force: false,
};

/**
 * Pure generate/consume flow reducer.
 * idle → starting → polling → delivered | failed; retry returns to starting.
 */
export function reelFlowReducer(
  state: ReelFlowState,
  event: ReelFlowEvent
): ReelFlowState {
  switch (event.type) {
    case 'RESET':
      return { ...INITIAL_REEL_FLOW_STATE };

    case 'OPEN_EXISTING':
      return {
        phase: 'delivered',
        jobId: event.jobId,
        force: false,
      };

    case 'ACQUIRE_START':
      if (state.phase === 'starting') return state;
      return {
        phase: 'starting',
        jobId: null,
        force: event.force,
      };

    case 'ACQUIRE_SUCCESS':
      if (state.phase !== 'starting') return state;
      return {
        phase: 'polling',
        jobId: event.jobId,
        force: state.force,
      };

    case 'ACQUIRE_FAILURE':
      if (state.phase !== 'starting') return state;
      return {
        ...state,
        phase: 'idle',
        jobId: null,
      };

    case 'POLL_DELIVERED':
      if (state.phase !== 'polling') return state;
      return { ...state, phase: 'delivered' };

    case 'POLL_FAILED':
      if (state.phase !== 'polling') return state;
      return { ...state, phase: 'failed' };

    case 'RETRY':
      if (state.phase !== 'failed' && state.phase !== 'idle') return state;
      return {
        phase: 'starting',
        jobId: null,
        force: state.force,
      };

    default:
      return state;
  }
}
